<template>
    <div class="row">
        <div class="col-md-3 custom-sidebar py-5">
            <h4 class="side-navbar-title mb-4">Users</h4>
            <div class="panel-group side-navbar">
                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 0 }"
                    @click.stop="open_item_selected(0)">Management Users</a>

                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 1 }"
                    @click.stop="open_item_selected(1)">Roles</a>

                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 2 }"
                    @click.stop="open_item_selected(2)">External Managers</a>
            </div>
        </div>
        <div class="col-md-9 pr-0">
            <div class="users-style">
                <h4 class="atlhr-dashboard-title mt-10 px-0 mb-3 pl-3 pb-3">
                    Company Users
                    <span>
                        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a>
                        / Users
                        <!-- Mustafijur: 17-05-2026: Starts -->
                        {{ tabIndexRFParent == 0 ? ' / Management Users' : '' }}
                        {{ tabIndexRFParent == 1 ? ' / Roles' : '' }}
                        {{ tabIndexRFParent == 2 ? ' / External Managers' : '' }}
                        <!-- Mustafijur: 17-05-2026: Ends -->
                    </span>
                </h4>
                <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>

                <div class="regulatory-filing-tab payroll-reporting-tab col-md-12">
                    <b-tabs pills content-class="" nav-class=" pr-2 m-2"
                        nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white d-none"
                        v-model="tabIndexRFParent">
                        <b-tab>
                            <!-- <template active v-slot:title>Users</template> -->
                            <div class="container-fluid reports-tab-nav">
                                <div class="row no-gutters py-2 mb-3">
                                    <div class="col-sm-6 pl-0">
                                        <div class="company-form-box-title custom-search">
                                            <b-input-group class="mb-2">
                                                <b-input-group-prepend is-text>
                                                    <b-icon icon="search"></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-input type="search" placeholder="Search Company User"
                                                    v-model="search" @input="resetPagination()"></b-form-input>
                                            </b-input-group>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 cursor-pointer text-right company-form-box-title pr-0">
                                        <b-button id="show-btn" @click="addNew()">+ Add New User</b-button>
                                    </div>
                                </div>

                                <table class="table dataTable">
                                    <thead>
                                        <tr class="table-head">
                                            <th v-for="column in columns" :key="column.name"
                                                @click="sortBy(column.name)"
                                                :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                style="cursor:pointer;"><span>{{ column.label }}</span></th>
                                            <!-- alpha fix- maked text center  -->
                                            <th class="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="hover-bg table-row mx-2" v-for="user in paginatedData"
                                            :key="user.id">
                                            <td>{{ user.name }}</td>
                                            <td>{{ user.email }}</td>
                                            <td><template v-if="user.phone">{{ formatPhoneNumber(user.phone)
                                                    }}</template>
                                            </td>
                                            <!--<td>{{assigned[user.assigned].text}}</td>-->
                                            <td>{{ roles[user.role_id] }}</td>
                                            <td>{{ status[user.status].text }}</td>
                                            <td class="text-right position-relative">
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu"
                                                    aria-labelledby="actionDropdown">
                                                    <b-button-group>
                                                        <!-- alpha fix added title  -->
                                                        <b-button variant="outline-secondary" title="Edit User"
                                                            @click="editCompanyUser(user.user_id)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </td>
                                        </tr>
                                        <!-- <tr v-if="paginatedData.length > 0">
                                            <td :colspan="6">
                                                <div class="row p-2 float-right" >
                                                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr> -->
                                    </tbody>
                                </table>

                                <!-- Mustafijur: 17-05-2026: Starts -->
                                <div>
                                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                                <li class="page-item disabled m-2">View</li>
                                                <li class="page-item disabled"><b-form-select v-model="temp_length"
                                                        :options="length_options"
                                                        @change="setFirstPage()"></b-form-select></li>
                                                <li class="page-item disabled m-2">per page. Total {{ people }} records
                                                    found.</li>
                                            </ul>
                                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                                                :number-of-pages="pagination.pages" prev-text="Previous"
                                                next-text="Next" base-url="#" first-number
                                                last-number></b-pagination-nav>
                                        </div>

                                    </div>
                                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                                        <span class="d-block text-center">{{ blankmsg }}</span>
                                        <img v-if="showoverlay" v-bind:src="$api_url + '/images/download-loader.svg'"
                                            class="loader-logo" width="100px" />
                                    </div>
                                </div>
                                <!-- Mustafijur: 17-05-2026: Ends -->
                            </div>



                        </b-tab>

                        <b-tab lazy>
                            <template active v-slot:title>Roles</template>
                            <roles-company></roles-company>
                        </b-tab>

                        <b-tab lazy>
                            <template active v-slot:title>External Managers</template>
                            <line-manager-index></line-manager-index>
                        </b-tab>

                    </b-tabs>
                </div>

                <b-modal id="bv-modal-example" size="lg" hide-footer :title="management_users">
                    <div class="custom-loader-wrapper" v-if="loader">
                        <div class="text-center">
                            <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                                width="100px" />
                        </div>
                    </div>
                    <ul>
                        <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
                    </ul>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmit">
                            <input type="hidden" v-model="fdata.id" name="id">

                            <!-- Abdullah26 added row and columns  -->
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="name-group" label="Name " class="required-field" label-for="name">
                                        <b-form-input id="name" name="name" v-model="fdata.name"
                                            v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                            aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="phone-group" label="Phone " class="required-field"
                                        label-for="phone">
                                        <b-input-group prepend="+880">
                                            <b-form-input id="phone" name="phone" v-model="fdata.phone"
                                                v-validate="{ required: true, min: 10, max: 10 }"
                                                :state="validateState('phone')" aria-describedby="phone-feedback"
                                                data-vv-as="Contact Number"></b-form-input>
                                            <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone')
                                                }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="role_id-group" class="required-field " label="Role "
                                        label-for="user_level">
                                        <b-form-select id="role_id" name="role_id" v-model="fdata.role_id"
                                            v-validate="{ required: true }" :options="roles"
                                            :state="validateState('role_id')" aria-describedby="role_id-feedback"
                                            data-vv-as="Role"></b-form-select>
                                        <b-form-invalid-feedback id="role_id-feedback">{{ veeErrors.first('role_id')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">

                                    <b-form-group id="email-group" class="required-field " label="Email"
                                        label-for="email">
                                        <b-form-input id="email" name="email" type="email" v-model="fdata.email"
                                            v-validate="{ required: true, min: 3, email: true }"
                                            :state="validateState('email')" aria-describedby="email-feedback"
                                            data-vv-as="Email"></b-form-input>
                                        <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="status-group" class="required-field " label="Status "
                                        label-for="status">
                                        <b-form-select id="status" name="status" v-model="fdata.status"
                                            v-validate="{ required: true }" :options="status"
                                            :state="validateState('status')" aria-describedby="status-feedback"
                                            data-vv-as="Status"></b-form-select>
                                        <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>
                            <!-- alpha fix- make the btn title dynamic  -->
                            <div class="full-width text-center">
                                <b-button class="btn-primary" type="submit" variant="success">{{ edit_user ? 'Update' :
                                    'Submit'
                                    }}</b-button>
                                <b-button class="ml-2 custom-wizard-btn btn-primary" variant="success"
                                    @click="resetForm()">Reset</b-button>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>

            </div>
        </div>
    </div>
</template>


<script>
export default {

    mounted() {
        //console.log('Bank info started..');
        //console.log(this.employee_id);
    },
    props: [],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Email', name: 'email' },
            { label: 'Phone', name: 'phone' },
            { label: 'Role', name: 'role_id' },
            { label: 'Status', name: 'Status' },
        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        return {
            disableme: false,
            users: [],
            companies: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { status: null, id: null, user_level: null, assigned: '1', password: 'pass1234', password_confirmation: 'pass1234', assigned_companies: [] },
            edit_user: false,
            blankmsg: 'Fetching data..',
            search: '',
            loader: false,

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

            status: [
                { value: null, text: "Select..." },
                { value: "1", text: "Active" },
                { value: "2", text: "Pending" },
                { value: "3", text: "Not Approved" },
                { value: "4", text: "Other" },
            ],
            user_level: [
                { value: null, text: "Select..." },
                { value: "2", text: "Admin" },
                { value: "3", text: "Manager" },
                { value: "4", text: "Executive" },
            ],
            assigned: [
                { value: "0", text: "No" },
                { value: "1", text: "Yes" },

            ],
            show_user_level: [
                { value: "0", text: "Select..." },
                { value: "1", text: "Select..." },
                { value: "2", text: "Admin" },
                { value: "3", text: "Manager" },
                { value: "4", text: "Executive" },
            ],


            roles: [],

            tabIndexRFParent: 0,

            management_users: 'Add New Management Users',

            // Mustafijur: 17-05-2026: Starts
            temp_length: 20,
            people: 0,
            length: 20,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            // Mustafijur: 17-05-2026: Ends
        }
    },
    methods: {
        open_item_selected: function (item) {
            this.tabIndexRFParent = item;
        },
        getUserTypeLevel: function () {
            axios.get(this.$api_url + '/user-type-level', {
                params: {

                }
            }).then(function (response) {

                if (response.data.user_type < 3) this.user_level = [{ value: null, text: "Select..." }, { value: 2, text: "Admin" }, { value: 3, text: "Manager" }, { value: 4, text: "Executive" },];
                else this.user_level = [{ value: null, text: "Select..." }, { value: 3, text: "Manager" }, { value: 4, text: "Executive" },];
            }.bind(this));
        },
        getCompanyUsers: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/company/userlist', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                //console.log(response.data);
                this.users = response.data;
                if (this.users.length == 0)
                    this.blankmsg = "Nothing found.";
                else
                    this.sortBy('name');

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        getRoles: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/acl/role/options/company', {
                params: {

                }
            }).then(function (response) {
                this.roles = response.data;

            }.bind(this)).catch(function (error) {
                //currentObj.serverError(error);
            });
        },
        editCompanyUser: function (x) {
            if (!this.checkNet()) return false;
            this.management_users = 'Edit Management User'; // Mustafijur: 14-05-2026
            let currentObj = this;

            axios.get(this.$api_url + '/company/user', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.phone = response.data.phone.slice(3, 15);
                this.disableme = true;
                this.$validator.reset();
                this.edit_user = true;
                this.successmsg = null;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

            this.$bvModal.show('bv-modal-example');
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { name: null, status: null, user_level: null, email: null, id: null, phone: null, assigned: 1, password: 'pass1234', password_confirmation: 'pass1234', };
            this.disableme = false;
            this.$nextTick(() => {
                this.$validator.reset();
            });

            this.errormsg = [];
        },
        addNew() {
            this.resetForm();
            this.edit_user = false;
            this.disableme = false;
            this.fdata.change_password = true;
            this.management_users = 'Add New Management Users'; // Mustafijur: 14-05-2026
            this.$bvModal.show('bv-modal-example');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.showoverlay = false;
                this.loader = true;
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/company/saveuser', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.users = response.data;

                        this.showoverlay = false;
                        this.loader = false;

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-example');
                        this.resetForm();

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                        currentObj.showoverlay = false;
                        currentObj.loader = false;
                    });
            });
        },

    },
    created: function () {
        this.getCompanyUsers();
        //this.getUserTypeLevel();

        this.getRoles();
        Fire.$on('reloadUsers', () => { this.getCompanyUsers() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.users;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            this.people = this.filteredData.length; // Mustafijur: 17-05-2026
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
